import * as S from './styles'
import { LoadingHavaianas } from 'components'

export interface LoadingModalProps {
  loadingText?: string
  title?: string
  description?: string
}

export const LoadingModal: React.FC<LoadingModalProps> = ({
  loadingText = 'Carregando...',
  title,
  description
}) => {
  return (
    <S.ModalWrapper>
      <S.ModalContent>
        <LoadingHavaianas
          loadingText={loadingText}
          description={description}
          title={title}
        />
      </S.ModalContent>
    </S.ModalWrapper>
  )
}
